import './styles.scss'

import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import satisfactionIcon from './_assets/satisfaction-icon.svg'

const NewGoodFit = ({ onClick }) => (
  <div className='good-fit-container'>
    <div className='good-fit-logo-container'>
      <img
        className='repeat-students-icon'
        alt='repeat students icon'
        src={`${satisfactionIcon}`}
        width={65}
        height={39}
      />
    </div>
    <div className='good-fit-text'>
      <span>{ReactHtmlParser(I18n.t('courses.show_good_fit.first_lesson_backed'))}</span>
      {` `}
      <span className='underline' onClick={onClick}>
        {I18n.t('courses.show_good_fit.new_good_fit')}
      </span>
    </div>
  </div>
)

NewGoodFit.propTypes = {
  onClick: PropTypes.func
}

export default NewGoodFit
